// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.nzjBf{position:relative;border-radius:8px;border:1px solid #d4d4e0;text-align:start;max-width:700px;width:100%}.nzjBf:not(.h6kjD).Pzfa4{border-color:var(--button-primary, #6942f8)}.nzjBf.aIF1O{padding:8px 4px;width:100%;max-width:100%}.nzjBf.aIF1O .hN0V4{position:absolute;top:0;right:0}.nzjBf.cvslf{background:var(--bg-light, #ffffff)}.nzjBf.h6kjD{background:var(--bg-standard, #f3f5ff)}.nzjBf.h6kjD.Pzfa4{border-color:var(--button-outline-on-secondary, var(--text-button-on-secondary-bg, var(--button-primary, #6942f8)))}.nzjBf.h6kjD:not(.aIF1O){width:700px;max-width:100%}.nzjBf:not(.aIF1O):not(.WB9Tv){max-width:700px}.nzjBf:not(.aIF1O){padding:16px}.nzjBf:not(.aIF1O):hover .r22j1{display:inline-flex}.nzjBf.WB9Tv{border-width:2px}.nzjBf.WB9Tv.aIF1O{padding:16px}.nzjBf.WB9Tv.aIF1O .hN0V4{position:static}.zyI80{position:relative;display:flex;align-items:center;gap:16px}.QvjhS{position:relative;display:flex;justify-content:center;align-items:center;width:69.14px;height:100%;min-height:70px}.y0Oku{flex:1;height:100%}.r22j1{display:none;position:absolute;right:12px}.lu3ht{position:absolute;top:0;right:0}.LxVr_{margin-top:8px}.WB9Tv .r22j1{position:static}.WB9Tv .ISPVf{display:flex;align-items:center;gap:4px;flex-shrink:0}.WB9Tv .lu3ht{position:static;flex-shrink:0}.WB9Tv .LxVr_{margin-top:0}.hN0V4{background:color-mix(in srgb, var(--button-primary, #6942f8) 15%, white) !important;border-color:var(--button-primary, #6942f8) !important;color:var(--badge-primary-color, var(--button-primary, #6942f8)) !important}.hN0V4 *{color:inherit !important}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"blue45": `#fcfcff`,
	"blue48": `#f5f7fd`,
	"blue50": `#f3f5ff`,
	"blue300": `#dae0ff`,
	"blue500": `#c0caff`,
	"blue600": `#a1aef5`,
	"blue700": `#8296ff`,
	"blue800": `#6176e7`,
	"dark50": `#fcfcfd`,
	"dark70": `#f4f4f7`,
	"dark100": `#eaeaef`,
	"dark120": `#e4e4ec`,
	"dark200": `#d4d4e0`,
	"dark300": `#bfbfd0`,
	"dark400": `#a9a9c1`,
	"dark500": `#9393b1`,
	"dark600": `#7e7ea1`,
	"dark700": `#696992`,
	"dark800": `#535382`,
	"dark900": `#282863`,
	"green45": `#eff6fa`,
	"green50": `#f3fcfa`,
	"green300": `#b6ebdf`,
	"green500": `#86ddca`,
	"green700": `#56d0b5`,
	"green800": `#36b89b`,
	"green900": `#089475`,
	"orange50": `#fdf2dc`,
	"orange300": `#fadea8`,
	"orange500": `#f9d797`,
	"orange700": `#f7ca75`,
	"orange800": `#f5bd52`,
	"orange900": `#dd9306`,
	"purple50": `#e1d9fe`,
	"purple300": `#c3b3fc`,
	"purple500": `#a58efb`,
	"purple700": `#8768f9`,
	"purple800": `#6942f8`,
	"purple900": `#4520cc`,
	"red200": `#fdf0f0`,
	"red300": `#fee3e3`,
	"red500": `#f9d5d5`,
	"red700": `#f3aaaa`,
	"red900": `#eb7272`,
	"red950": `#e86161`,
	"red970": `#dd4c4c`,
	"white": `#fff`,
	"defaultTextStandard": `#282863`,
	"defaultTextSecondary": `#696992`,
	"defaultButtonPrimary": `#6942f8`,
	"buttonPrimary": `var(--button-primary, #6942f8)`,
	"buttonPrimaryDark": `var(--button-primary-dark, #4520cc)`,
	"buttonDisabled": `var(--button-disabled, #bfbfd0)`,
	"buttonDisabledDark": `var(--button-disabled-dark, #a9a9c1)`,
	"defaultButtonDisabled": `#bfbfd0`,
	"defaultStepperCompleted": `#089475`,
	"defaultStepperIncomplete": `#d4d4e0`,
	"defaultButtonSecondary": `#fcfcfd`,
	"defaultBgStandard": `#f3f5ff`,
	"defaultBgLight": `#fff`,
	"sh10": `0px 4px 12px rgba(40,40,99,.06)`,
	"sh20": `0px 4px 16px rgba(40,40,99,.08)`,
	"sh40": `0px 4px 24px rgba(40,40,99,.12)`,
	"sh60": `0px 4px 14px rgba(40,40,99,.24)`,
	"fontFamilyLight": `"Lufga-Regular"`,
	"fontFamilyNormal": `"Lufga-Medium"`,
	"fontFamilyBold": `"Lufga-SemiBold"`,
	"fontSizeH1": `var(--font-size-h1, 48px)`,
	"fontSizeH2": `var(--font-size-h2, 40px)`,
	"fontSizeH3": `var(--font-size-h3, 33px)`,
	"fontSizeH4": `var(--font-size-h4, 28px)`,
	"fontSizeH5": `var(--font-size-h5, 22px)`,
	"fontSizeH6": `var(--font-size-h6, 20px)`,
	"fontSizeP1": `var(--font-size-p1, 16px)`,
	"fontSizeP2": `var(--font-size-p2, 14px)`,
	"fontSizeP3": `var(--font-size-p3, 12px)`,
	"lineHeightH1": `var(--line-height-h1, 64px)`,
	"lineHeightH2": `var(--line-height-h2, 56px)`,
	"lineHeightH3": `var(--line-height-h3, 40px)`,
	"lineHeightH4": `var(--line-height-h4, 40px)`,
	"lineHeightH5": `var(--line-height-h5, 32px)`,
	"lineHeightH6": `var(--line-height-h6, 35px)`,
	"lineHeightP1": `var(--line-height-p1, 24px)`,
	"lineHeightP2": `var(--line-height-p2, 18px)`,
	"lineHeightP3": `var(--line-height-p3, 16px)`,
	"paymentMethod": `nzjBf`,
	"bgClientOnboarding": `h6kjD`,
	"selected": `Pzfa4`,
	"isMobile": `aIF1O`,
	"selectedBadge": `hN0V4`,
	"bgAgreementMinisite": `cvslf`,
	"newFlow": `WB9Tv`,
	"selectBtn": `r22j1`,
	"inner": `zyI80`,
	"logo": `QvjhS`,
	"content": `y0Oku`,
	"removeBtn": `lu3ht`,
	"footer": `LxVr_`,
	"actionsRow": `ISPVf`
};
export default ___CSS_LOADER_EXPORT___;
